import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const waitlistList = (params = '') => Http.get(`/admin/ventures/waitlist${serialize(params)}`)
export const waitlistByID = (params = '') => Http.get(`/admin/ventures/waitlist/${params}`)
export const waitlistDelete = (id) => Http.delete(`/admin/ventures/waitlist/${id}`)
export const waitlistInvite = (id) => Http.post(`/admin/ventures/waitlist/${id}/invite`)
